import { action, extendObservable } from 'mobx';
import FetchService from '../../../core/services/FetchService';
import FormService from '../../../core/services/FormService';

class FileRepositoryTreeService {
  fetch = new FetchService();
  form = new FormService();

  constructor() {
    extendObservable(this, {
      attachmentRepositories: [],
    });
  }

  init = action(() => {
    this.attachmentRepositories = [];
    this.load();
  });

  load = action(() => {
    this.fetch
      .fetch({
        url: '/attachment-repositories',
        apiVersion: 'v3',
      })
      .then(() => {
        if (this.fetch.data) {
          this.attachmentRepositories = this.fetch.data;
        } else {
          this.attachmentRepositories = [];
        }
      });
  });
}

const fileRepositoryListService = new FileRepositoryTreeService();

export default fileRepositoryListService;
